exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".edit{display:block}.edit .days-placeholder{flex-grow:0;margin-top:3.5rem}.edit .edit-submit-buttons{margin-top:1.5rem;text-align:right}.edit .edit-submit-buttons button{margin-bottom:1rem}.form__wrap__group--single{margin-top:56px}.form__wrap__group--single select{height:50px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-702ca2e2","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./_source/javascripts/modules/profile/ticketsConfig.vue
// module id = 465
// module chunks = 0